<!--
=============================================================================
setera-web
=============================================================================
Copyright (c) 2026 HG Digital/Setera
Todos os direitos reservados.

Este software é confidencial e de propriedade da HG Digital/Setera.
Seu uso está sujeito aos termos do contrato de licença.
-----
Criado em : 18-09-2026 11:50:03
Autor     : Diego Brock
Projeto   : setera-web
Versão    : 1.0.0
=============================================================================
-->
<h2 mat-dialog-title>{{ title }}</h2>
<div mat-dialog-content>
  <p class="confirm-message">{{ message }}</p>
</div>
<div mat-dialog-actions align="end" class="confirm-actions">
  <button mat-button type="button" (click)="cancel()">Não</button>
  <button
    mat-flat-button
    type="button"
    [color]="warn ? 'warn' : 'primary'"
    (click)="confirm()">
    {{ confirmLabel }}
  </button>
</div>
